// @flow

import LadderInsuranceService from 'web-core/src/ladder-insurance-service';
import type { Dispatch } from 'redux';

type LifeAction = {
  type: 'RECEIVE_LIFE_PLAN',
  lifePlan: Object,
};

export type LadderGenderType = 'male' | 'female';

export function fetchLadderQuote({
  coverage,
  dob,
  familyHistory,
  gender,
  height,
  householdIncome,
  term,
  tobacco,
  weight,
}: {
  coverage: number,
  dob: string,
  familyHistory: boolean,
  gender: LadderGenderType,
  height: number,
  householdIncome: number,
  term: number,
  tobacco: boolean,
  weight: number,
}) {
  return (dispatch: Dispatch<LifeAction>, getState: () => Object, { apiClient }: Object) => {
    const svc = new LadderInsuranceService({ client: apiClient });
    return svc.getQuotes({
      coverage,
      dob,
      familyHistory,
      gender,
      height,
      householdIncome,
      term,
      tobacco,
      weight,
    });
  };
}

export function fetchLadderPlanUrl(id: string, payload: Object) {
  return (dispatch: Dispatch<LifeAction>, getState: () => Object, { apiClient }: Object) => {
    const svc = new LadderInsuranceService({ client: apiClient });
    return svc.postPlan(id, payload);
  };
}
